import { A365BackendModel as Model } from '../a365.backendmodel';
import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { SparkConfiguration } from '../sparkconfiguration/sparkconfiguration';
import { NamedAdapter } from './named.adapter';
import { ModelConstants } from '../model-constants';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SparkConfiguration),
    adapts: {
        name: '*',
        properties: {
            description: '*',
            configs: '*',
            notes: '*',
            created: '*',
            createdBy: '*',
            annotations: '*'
        }
    }
})
export class SparkConfigurationAdapter extends NamedAdapter<SparkConfiguration, Model.SparkConfigurationResource> {
    protected _toResource(model: SparkConfiguration): Model.SparkConfigurationResource {
        const resource = super._toResource(model) as Model.SparkConfigurationResource;
        const properties = this.properties(resource);
        properties.configs = model.configs;
        properties.created = model.date;
        properties.createdBy = model.createdBy;
        properties.annotations = model.annotations;
        properties.configMergeRule = model.configMergeRule;
        return resource;
    }

    protected _toModel(resource: Model.SparkConfigurationResource, model?: SparkConfiguration): SparkConfiguration {
        if (!model) {
            model = SparkConfiguration.MODEL.create<SparkConfiguration>();
        }
        super._toModel(resource, model);
        model.annotations = resource.properties?.annotations;
        model.configs = resource.properties?.configs;
        model.date = resource.properties?.created;
        model.createdBy = resource.properties?.createdBy;
        model.rawTags = resource.tags;
        model.resourceType = ModelConstants.sparkConfiguration.toLowerCase() + 's';
        model.configMergeRule = resource.properties?.configMergeRule;
        return model;
    }
}
